@if (loading()) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
<mat-toolbar>

  <span class="spacer"></span>

  <a mat-flat-button
     routerLink="../../chat"
     aria-label="Open Settings dialog"
  >
    <mat-icon>tune</mat-icon>
    <span>Back to Chat</span>
  </a>
</mat-toolbar>

@if (paperHasEmbeddings(); as paperHasEmbeddings) {

  <div class="embedding-list">
    @for (paperHasEmbedding of paperHasEmbeddings; track paperHasEmbedding.paperId) {
      <app-paper-has-embedding-paper-card [hasEmbedding]="paperHasEmbedding"
                                          [projectId]="project()!.id"></app-paper-has-embedding-paper-card>
    }
  </div>
}
